<div class="container-fluid full-page-height">
    <div class="row mb-16">
        <div class="col-12 col-lg-4">
            <h2 class="m-0 mb-0">Administration</h2>
        </div>
    </div>
    <div class="dhhpCardContain">
        <dhhp-card class="p-3 home-card-container">
            <div class="d-flex admin-card-container form-full-container flex-wrap pt-2 pl-2 mb-5">

                <dhhp-card class="manage-div hidediv">
                    <div class="d-flex cursor justify-content-center admin-container p-3 mb-2">
                        <img class="assets-icon material-icons" src="assets/img/svg/app-manager/icon_configure.svg" />
                        <img class="assets-icon-hover" src="assets/img/svg/app-manager/icon_configure-hover.svg" />
                    </div>
                    <p class="font-weight-bold cursor mt-2 mb-0">Applications Onboarding</p>
                    <p class="line-h-16 m-0"><small>Application onboarding here.</small></p>
                    <img class="aterial-icons ssets-icon-hover favorite-img cursor"/>
                </dhhp-card>
            </div>
        </dhhp-card>
    </div>
</div>